import { render, staticRenderFns } from "./kk-mail.vue?vue&type=template&id=672f95c9&"
import script from "./kk-mail.vue?vue&type=script&lang=js&"
export * from "./kk-mail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports